import React from 'react'
import { connect } from 'react-redux'
import { Prompt } from 'react-router-dom'
import { isEqual } from 'lodash'
import language from 'utils/vast-languagepack'

export default connect(
	(state) => ({
		changed: state.signupForm.addOrEdit.changed,
		values: state.signupForm.addOrEdit.values,
		fields: state.signupForm.addOrEdit.fields,
		saveAttempted: state.signupForm.addOrEdit.saveAttempted,
		stepper: state.view.stepper.form,
		formID: state.signupForm.addOrEdit.formID,
		anyChangedCustom: state.customForm.addOrEdit.anyChanged,
	}),
	null,
)(
	({
		changed,
		values,
		fields,
		saveAttempted,
		stepper,
		formID,
		anyChangedCustom,
	}) => {
		let when = false

		if ((changed.anyChanged || anyChangedCustom) && !saveAttempted) {
			if (formID === 'new') {
				// console.log('hits if formid is new and stepper is 0')
				if (
					Object.keys(changed.changedValues).length === 1 &&
					Object.keys(changed.changedValues)[0] === 'formName'
				) {
					when = false
				} else {
					Object.keys(changed.changedValues).forEach((changedValue) => {
						if (
							values[changedValue].value !== values[changedValue].initialValue
						) {
							when = true
						}
					})
					if (!isEqual(changed.initialFields, fields)) {
						when = true
					}
				}
			} else {
				Object.keys(changed.changedValues).forEach((changedValue) => {
					if (
						values[changedValue].value !== values[changedValue].initialValue
					) {
						when = true
					}
				})
				if (!isEqual(changed.initialFields, fields)) {
					when = true
				}
			}
		}

		return (
			<Prompt when={when} message={language.signupform.add.discardChanges} />
		)
	},
)
